<!-- add form include title and checkbox for each feature -->
<template>
  <div class="features-access">
    <api-errors :errors="errors" />
    <el-row>
      <el-col :span="24">
        <el-form :model="form" ref="form">
          <!-- <div class="fa-label">{{ $t("organization_page.menu.feature_access") }}</div> -->
          <el-form-item v-for="({ value, label }, idx) in availableFeatures" :key="idx">
            <el-switch v-model="form.featuresAccess[value]" :active-text="label" @change="handleToggle(value)" />
          </el-form-item>
        </el-form>
        <div class="form-actions">
          <primary-button
            @click.native="submitForm"
            ref="submit"
            :disabled="isSubmitDisabled"
            v-loading.fullscreen.lock="loading"
          >
            {{ $t("organization_profile.edit_organization_modal.save") }}
          </primary-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { handleFormValidation } from "@/helpers/formValidationHelper";
import { successMessage } from "@/utils/messages";
import PrimaryButton from "@/components/common/buttons/PrimaryButton";
import ApiErrors from "@/components/common/ApiErrors";
import { ELSA_AI } from "@/constants/generic";

export default {
  components: {
    PrimaryButton,
    ApiErrors,
  },
  props: {
    organization: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        featuresAccess: this.initializeFeaturesAccess(this.organization.dashboard_features_avaiable),
      },
      originalForm: {},
      availableFeatures: [{ value: ELSA_AI, label: "ELSA AI" }],
      loading: false,
      errors: [],
      isSubmitDisabled: true,
    };
  },
  mounted() {
    this.resetForm();
  },
  computed: {
    ...mapGetters("user", ["isAdmin"]),
  },
  methods: {
    initializeFeaturesAccess(features) {
      let featuresAccess = {};
      features.forEach(feature => {
        featuresAccess[feature] = true;
      });
      return featuresAccess;
    },
    hasFormChanged() {
      return JSON.stringify(this.form.featuresAccess) !== JSON.stringify(this.originalForm.featuresAccess);
    },
    async submitRequest() {
      const organizationFormObject = {
        dashboard_features_avaiable: Object.keys(this.form.featuresAccess).filter(key => this.form.featuresAccess[key]),
      };
      const organizationObject = organizationFormObject;
      try {
        this.loading = true;
        const organization = await this.partialUpdateOrganization({
          id: this.organization.id,
          organization: organizationObject,
        });
        await this.$store.dispatch("organization/setCurrentOrganizationData", organization);
        this.resetForm();
        this.loading = false;
        successMessage(this.$t("organization_profile.edit_organization_modal.update_feature_accesss_success"))(this);
      } catch (error) {
        this.loading = false;
        this.errors = error;
      }
    },
    submitForm() {
      handleFormValidation(this.$refs.form, this.submitRequest, () => {
        return true;
      });
    },
    checkFormChanges() {
      this.isSubmitDisabled = !this.hasFormChanged();
    },
    resetForm() {
      this.originalForm = JSON.parse(JSON.stringify(this.form));
      this.checkFormChanges();
    },
    handleToggle(feature) {
      if (!this.form.featuresAccess[feature]) {
        this.$delete(this.form.featuresAccess, feature);
      } else {
        this.$set(this.form.featuresAccess, feature, true);
      }
      this.checkFormChanges();
    },
    ...mapActions({
      partialUpdateOrganization: "admin/partialUpdateOrganization",
    }),
  },
  watch: {
    form: {
      handler() {
        this.checkFormChanges();
      },
      deep: true,
    },
  },
};
</script>
<style scoped lang="scss">
.features-access {
  padding: 20px;
  .fa-label {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 20px;
  }
  .el-form {
    margin-bottom: 20px;
    .el-checkbox {
      margin-bottom: 10px;
    }
  }
}
</style>
